import { VFlow } from 'bold-ui'
import { ErrorField } from 'components/form/core/ErrorField/ErrorField'
import { MetaPath } from 'util/metaPath'
import {
  CuidadoCompartilhadoModel,
  CuidadoCompartilhadoVideochamadaState,
  DiscussaoCasoExecutanteFieldsModel,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

import { AgendarConsultaCuidadoCompartilhadoField } from '../components/discussao-caso-fields/AgendarConsultaCuidadoCompartilhadoField'
import { DevolutivaCuidadoCompartilhadoField } from '../components/discussao-caso-fields/DevolutivaCuidadoCompartilhadoField'
import { SugestaoAgendamentoGrupoCuidadoCompartilhadoField } from '../components/discussao-caso-fields/SugestaoAgendamentoGrupoCuidadoCompartilhadoField'
import { TrocaExecutanteCuidadoCompartilhadoField } from '../components/discussao-caso-fields/TrocaExecutanteCuidadoCompartilhadoField'
import { OnCondutaGroupChangeCallback } from './DiscussaoCasoFieldGroup'

interface DiscussaoCasoExecutanteFieldsProps {
  path: MetaPath<DiscussaoCasoExecutanteFieldsModel>
  cuidadoCompartilhado: CuidadoCompartilhadoModel
  videochamadaUuidState: CuidadoCompartilhadoVideochamadaState
  isEspecializada: boolean
  isExecutanteFromEstabelecimentoEspecializado: boolean
  onCondutaGroupChange: OnCondutaGroupChangeCallback
}

export const DiscussaoCasoExecutanteFields = (props: DiscussaoCasoExecutanteFieldsProps) => {
  const {
    path,
    cuidadoCompartilhado,
    videochamadaUuidState,
    isEspecializada,
    isExecutanteFromEstabelecimentoEspecializado,
    onCondutaGroupChange,
  } = props

  const { lotacaoSolicitante, lotacaoExecutanteAtual, unidadeSaudeExecutanteAtual, cidadao } = cuidadoCompartilhado

  return (
    <VFlow vSpacing={0.5}>
      <DevolutivaCuidadoCompartilhadoField
        path={path}
        cidadaoFaleceu={cidadao.faleceu}
        onCondutaGroupChange={onCondutaGroupChange}
      />

      {!cidadao.faleceu && (
        <VFlow vSpacing={0.5}>
          <TrocaExecutanteCuidadoCompartilhadoField
            path={path}
            lotacaoSolicitante={lotacaoSolicitante}
            profissionalExecutanteId={lotacaoExecutanteAtual.profissional.id}
            equipeExecutanteId={lotacaoExecutanteAtual.equipe?.id}
            unidadeSaudeExecutanteId={unidadeSaudeExecutanteAtual.id}
            isEspecializada={isEspecializada}
            onCondutaGroupChange={onCondutaGroupChange}
          />

          {!isExecutanteFromEstabelecimentoEspecializado && (
            <AgendarConsultaCuidadoCompartilhadoField
              path={path}
              cuidadoCompartilhado={cuidadoCompartilhado}
              videochamadaUuidState={videochamadaUuidState}
              onCondutaGroupChange={onCondutaGroupChange}
            />
          )}

          <SugestaoAgendamentoGrupoCuidadoCompartilhadoField path={path} onCondutaGroupChange={onCondutaGroupChange} />
        </VFlow>
      )}

      <ErrorField name={path} ignoreObjectError />
    </VFlow>
  )
}
